import { useEffect, useState } from 'react';
import apiService, { ServiceType } from '../services/api';

export interface PolicyRow {
  strategy: 'GRID' | 'PAIR';
  kind: string;
  field: string;
  stopped: 'APPLY' | 'PENDING' | 'REFUSE';
  running: 'APPLY' | 'PENDING' | 'REFUSE';
  note: string;
}

// one read per page load: the table only changes with a BE release
let cached: Promise<PolicyRow[]> | null = null;
const load = () =>
  (cached ??= apiService.getService(ServiceType.CORE).get<PolicyRow[]>('/change-policy')
    .then((r) => (Array.isArray(r.data) ? r.data : []))
    .catch(() => { cached = null; return []; }));

/** The BE's change policy (GET /change-policy): what may change while a bot runs. The terminal
 *  reads the same table, so both screens lock the same fields for the same reason. Until it has
 *  loaded nothing is locked here; the BE refuses the change anyway. */
export function useChangePolicy() {
  const [rows, setRows] = useState<PolicyRow[]>([]);
  useEffect(() => {
    let live = true;
    void load().then((r) => live && setRows(r));
    return () => { live = false; };
  }, []);
  const refusedWhileRunning = (strategy: PolicyRow['strategy'], field: string) =>
    rows.some((r) => r.strategy === strategy && r.field === field && r.running === 'REFUSE');
  return { rows, refusedWhileRunning };
}

export const __resetChangePolicyCache = () => { cached = null; };
